import { z } from 'zod';
import { decode } from './zodDecoder';

const ExternalPartnerIntegrationC = z.object({
    integration_id: z.string(),
    account_id: z.string(),
    client_id: z.string(),
    tag_id: z.string().nullish(),
});

export type ExternalPartnerIntegration = z.infer<typeof ExternalPartnerIntegrationC>;

const PartnerIntegrationC = z.object({
    integrationId: z.string(),
    accountId: z.string(),
    clientId: z.string(),
});

export type PartnerIntegration = z.infer<typeof PartnerIntegrationC>;

const PartnerIntegrationApiResponseC = z.object({ items: z.array(ExternalPartnerIntegrationC) });
export type PartnerIntegrationApiResponse = z.infer<typeof PartnerIntegrationApiResponseC>;

const mapExternalToInternalPartnerIntegration = (input: ExternalPartnerIntegration): PartnerIntegration => ({
    integrationId: input.integration_id,
    clientId: input.client_id,
    accountId: input.account_id,
});

const mapAll = (input: ExternalPartnerIntegration[]): PartnerIntegration[] =>
    input.map(it => mapExternalToInternalPartnerIntegration(it));

const decodePartnerIntegrationQueryApiResponse = (input: unknown): PartnerIntegrationApiResponse =>
    decode(input, PartnerIntegrationApiResponseC);

const decodePartnerIntegrationByIdApiResponse = (input: unknown): ExternalPartnerIntegration =>
    decode(input, ExternalPartnerIntegrationC);

const extractItems = (input: PartnerIntegrationApiResponse): ExternalPartnerIntegration[] => input.items;

export const convertPartnerIntegrationQueryApiResponse = (input: unknown): PartnerIntegration[] =>
    mapAll(extractItems(decodePartnerIntegrationQueryApiResponse(input)));

export const convertPartnerIntegrationByIdApiResponse = (input: unknown): PartnerIntegration =>
    mapExternalToInternalPartnerIntegration(decodePartnerIntegrationByIdApiResponse(input));
